import { render, staticRenderFns } from "./NewOrderConfirm.vue?vue&type=template&id=2980362a&"
import script from "./NewOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./NewOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderConfirm.vue?vue&type=style&index=0&id=2980362a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports